module.exports = require("react-places-autocomplete");